import React, { useState, useEffect } from 'react';
import { Box, Modal } from '@mui/material';
import VuiBox from 'components/VuiBox';
import { useWallet } from 'WalletProvider';
import { ChainId, LiFiWidget } from '@lifi/widget';
import { WagmiProvider } from 'wagmi';
import { config } from 'index';
import { chainConfig } from 'viem/zksync';


  export const LiFiModal = ({ 
    isOpen, 
    onClose, 
    buyToken
  }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { wallet, selectedChain } = useWallet();

    const lificonfig = {
        variant: "wide",
        subvariant: "default",
        appearance: "auto",
        fromChain: selectedChain,
        toToken: buyToken,
        chains: {
          allow: [8453],
        },
        sdkConfig: {
            rpcUrls: {
              [ChainId.BAS]: [`https://base-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_API_KEY}`]
            },
          },
        theme: {
          palette: {
            primary: {
              main: "#5C67FF"
            },
            secondary: {
              main: "#F5B5FF"
            }
          },
          typography: {
            fontFamily: "Inter, sans-serif"
          },
          container: {
            boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.08)",
            borderRadius: "16px"
          }
        },
        walletConfig: {
          onConnect: ()=>{e==null||e()}
        }
      }
  
    // Safe close handler
    const handleClose = () => {
      if (!isLoading) {
        onClose();
      }
    };
  
    return (
      <VuiBox p={2}>
        <Modal
          open={isOpen}
          onClose={handleClose}
          aria-labelledby="swap-modal-title"
          aria-describedby="swap-modal-description"
        >
          <Box
            tabIndex={-1}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              // width: 550, // Slightly wider to accommodate widget
              // maxWidth: "95%",
              bgcolor: "background.paper",
              background: "rgba(19, 21, 34, 0.95)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              borderRadius: "15px",
              boxShadow: 24,
              outline: "none",
            }}
          >
            <VuiBox p={3}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                {/* <h2 id="swap-modal-title" style={{ margin: 0, color: 'white' }}>Buy</h2> */}
                <button 
                  onClick={handleClose}
                  style={{ 
                    background: 'none', 
                    border: 'none', 
                    color: 'white', 
                    fontSize: '1.5rem',
                    cursor: 'pointer' 
                  }}
                >
                  ×
                </button>
              </Box>
              
              <div style={{ minHeight: '400px' }}>
                {/* Pass all props directly without using defaultProps */}
                <WagmiProvider config={config} reconnectOnMount>
                    <LiFiWidget integrator="merge.markets" config={lificonfig} />
                </WagmiProvider>
               
              </div>
            </VuiBox>
          </Box>
        </Modal>
      </VuiBox>
    );
  };